import { GuaranteeTypeEnum } from '@insurance/api/requests'
import { Text } from '@shared/components'
import { Card, Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { FIXED_BENEFICIARY_LABEL_KEY } from './utils'

type Props = {
  guaranteeType: GuaranteeTypeEnum
}

export const FixedBeneficiary = ({ guaranteeType }: Props) => {
  const { t } = useTranslation()

  const labelKey = FIXED_BENEFICIARY_LABEL_KEY[guaranteeType]

  if (!labelKey) return null

  return (
    <Flex vertical gap={12}>
      <Text size={16} strong>
        {t('beneficiary')}
      </Text>

      <Card size="small">
        <Flex vertical gap={4}>
          <Text strong>{t(labelKey)}</Text>
          <Text type="secondary">{t('system_filled_beneficiary')}</Text>
        </Flex>
      </Card>
    </Flex>
  )
}
